import script from "./FeatherIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatherIcon.vue?vue&type=script&setup=true&lang=js"

import "./FeatherIcon.vue?vue&type=style&index=0&id=c6cfb152&lang=scss"

const __exports__ = script;

export default __exports__